module.exports = __webpack_public_path__ + "static/media/RD_Team_image_2_blue.d77ea84b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/RD_Team_image_2_blue.jpg
// module id = 75
// module chunks = 0